import { get } from 'lodash'
import { useQuery } from 'react-query'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'

import { Garbage } from '../types'
import { Meta } from '@/features/filters/types'

import { GARBAGES } from '../constants'

type GarbagesResponse = {
  data: Garbage[]
  meta: Meta
}

const getGarbages = async (params: Meta): Promise<GarbagesResponse> => {
  const response = await fetchAPI({
    path: '/garbages',
    params,
  })

  const data = get(response, 'data.garbages', [])
  const meta = get(response, 'data.meta', {})

  return { data, meta }
}

export const useGarbages = ({
  params = {},
  initialData,
}: {
  params?: Meta
  initialData?: GarbagesResponse
}) => {
  return useQuery<GarbagesResponse, AxiosError>({
    queryKey: [GARBAGES, params],
    queryFn: () => getGarbages(params),
    keepPreviousData: true,
    initialData,
  })
}
